import { palette } from "./palette";
import { colors } from "./colors";

export const formHelperText = {
  root: {
    fontSize: "1rem",
    color: "#484848",
    "&$error": {
      color: "#972323"
    }
  }
};
